/*
 ** Author: Nuno Alex
 ** Date: 10/2024
 ** Test: GLX-011 Mobile Burger Menu: Add Search Functionality Bar
 ** Variation: Variation-2
 */

(() => {
	const debugMode = 1,
		testId = "GLX-011",
		logInfo = testId + " -->",
		variation = 2;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			_window._conv_q = _window._conv_q || [];

			function waitForElements(cssSelector, multi, callback, maxCalls) {
				try {
					var elementsCached; // [Configurable] Times out after 6 seconds

					var interval = setInterval(function () {
						try {
							if (multi) {
								elementsCached = document.querySelectorAll(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached.length) {
									clearInterval(interval);
									callback(elementsCached);
								}
							} else {
								elementsCached = document.querySelector(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached) {
									clearInterval(interval);
									callback(elementsCached);
								}
							}

							// After trying to find the element for 6 seconds, it stops

							if (typeof maxCalls === "number" && --maxCalls < 0) {
								clearInterval(interval);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					}, 20);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			}

			// Send Convert event
			const sendConvertEvent = (number, label = "") => {
				try {
					_conv_q.push(["triggerConversion", number]);

					if (debugMode) console.log(logInfo, "Convert event sent:", number, label);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElements("header-sidebar .header-sidebar__main-panel ul.header-sidebar__linklist li", false, (liElement) => {
				try {
					liElement.insertAdjacentHTML(
						"beforeBegin",
						`
							<li class="${testId}-search-container">
								<div>
									<div>
										<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M17 17L12.6549 12.6548M14.6642 7.83215C14.6642 11.6054 11.6054 14.6643 7.83212 14.6643C4.05884 14.6643 1 11.6054 1 7.83215C1 4.05886 4.05884 1 7.83212 1C11.6054 1 14.6642 4.05886 14.6642 7.83215Z" stroke="#3B3B3B" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<span>SEARCH</span>
									</div>
									<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M13 1L1 13M1 1L13 13" stroke="#151515" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
							</li>
						`
					);

					const originalHeaderSearchIcon = document.querySelector('header nav.header__secondary-nav a[href="/search"]');

					const newLiElement = document.querySelector(`.${testId}-search-container`);

					newLiElement.addEventListener("click", (e) => {
						try {
							e.preventDefault();
							e.stopPropagation();
							e.stopImmediatePropagation();

							originalHeaderSearchIcon.click();

							const searchInput = document.querySelector("header header-search #predictive-search-form input");
							if (searchInput) {
								setTimeout(() => {
									searchInput.focus();
								}, 250);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();